import { StatusTone, TONE_BADGE } from './statusColors';

/**
 * Selo da coluna "Fat. Período" (Assinaturas): o status da fatura da competência.
 *
 * Até 05/10/2026 era `status === 'Aberta' ? open : warning`, um ternário de DOIS valores.
 * Com o campo lido do cache, só apareciam "Aberta" e "Rascunho", e âmbar queria dizer
 * "rascunho, pendente". Quando a coluna passou a ler a fatura (backend #334), "Paga"
 * passou a existir, e a fatura paga, melhor notícia da coluna, saiu vestida de alerta.
 * O domínio é mapeado por inteiro; o que não estiver no mapa sai neutro, nunca como
 * alerta nem como sucesso. E campo vazio não vira "Rascunho": diz que não sabe.
 */
const TOM: Record<string, StatusTone> = {
  Rascunho: 'warning', // o único que pede ação
  Aberta: 'open',
  // Neutro, não sucesso: estado terminal, não pede nada de ninguém. Em verde ficava
  // indistinguível de 'Aberta' (green-400 x emerald-400, medido em produção 05/10/2026).
  Paga: 'neutral',
  Vencida: 'danger',
};

export function seloDaFaturaDoPeriodo(status: string | null | undefined): { texto: string; classe: string } {
  if (!status) return { texto: 'sem status', classe: TONE_BADGE.neutral };
  return { texto: status, classe: TONE_BADGE[TOM[status] ?? 'neutral'] };
}
